import { put, call } from 'redux-saga/effects';
import { registerUserService, loginUserService,getDSDangChoService,getChiTietCLSService,saveDataCLSService,getDSHoanTatService } from '../services/authenticationService';

import * as types from '../actions'

export function* registerSaga(payload) {
  try {
    const response = yield call(registerUserService, payload);
    yield put({ type: types.REGISTER_USER_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.REGISTER_USER_ERROR, error });
  }
}

export function* loginSaga(payload) {
  try {
    const response = yield call(loginUserService, payload); 
    yield  put({ type: types.LOGIN_USER_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.LOGIN_USER_ERROR, error })
  }
} 
export function* dataGetDSDangChoSaga(payload) {
  try {
    const response = yield call(getDSDangChoService, payload); 
    yield  put({ type: types.DATA_DSDANGCHO_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.DATA_DSDANGCHO_ERROR, error })
  }
}
export function* dataChiTietCLSSaga(payload) {
  try {
    const response = yield call(getChiTietCLSService, payload); 
    yield  put({ type: types.DATA_CHITIETCLS_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.DATA_CHITIETCLS_ERROR, error })
  }
}

export function* saveDataCLSSaga(payload) {
  try {
    const response = yield call(saveDataCLSService, payload); 
    yield  put({ type: types.SAVE_DATA_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.SAVE_DATA_ERROR, error })
  }
}


export function* dataGetDSHoanTatSaga(payload) {
  try {
    const response = yield call(getDSHoanTatService, payload); 
    yield  put({ type: types.DATA_DSHOANTAT_SUCCESS, response });
  } catch(error) {
    yield put({ type: types.DATA_DSHOANTAT_ERROR, error })
  }
}